import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { repositories } from '@/data'
import { useSessionStore } from '@/lib/session.store'

export function useLogout(): { logout: () => Promise<void>; isLoggingOut: boolean } {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  async function logout() {
    if (isLoggingOut) return
    setIsLoggingOut(true)
    try {
      // Best-effort server-side cleanup (clears refresh token + impersonation cookie).
      // Local logout still happens even if this fails (network error, expired token, etc.).
      try {
        await repositories.auth.logout()
      } catch {
        // swallow — local clear runs unconditionally
      }
      useSessionStore.getState().logout()
      queryClient.clear()
      await navigate({ to: '/login' })
    } finally {
      setIsLoggingOut(false)
    }
  }

  return { logout, isLoggingOut }
}
